"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PoliciesStoreService = /** @class */ (function () {
    function PoliciesStoreService(VueStoreFactory) {
        this.VueStoreFactory = VueStoreFactory;
    }
    PoliciesStoreService.prototype.getPolicy = function (name) {
        var wrapper = this.VueStoreFactory.state.auth.policies;
        var policies = (wrapper && wrapper.policies) || [];
        var policy = policies.find(function (p) { return p.name === name; });
        if (!policy) {
            return null;
        }
        var policymeta = {};
        policy.policymeta.forEach(function (meta) {
            policymeta[meta.meta_key] = meta.meta_value;
        });
        return { id: policy.id, policymeta: policymeta };
    };
    PoliciesStoreService.prototype.writePolicy = function (name, editedPolicymeta) {
        var currentWrapper = this.VueStoreFactory.state.auth.policies;
        if (!currentWrapper || !currentWrapper.policies) {
            return;
        }
        var updatedPolicies = currentWrapper.policies.map(function (p) {
            if (p.name !== name) {
                return p;
            }
            var updatedPolicymeta = p.policymeta.map(function (meta) {
                if (meta.meta_key !== "id" && meta.meta_key in editedPolicymeta) {
                    return __assign(__assign({}, meta), { meta_value: editedPolicymeta[meta.meta_key] });
                }
                return meta;
            });
            return __assign(__assign({}, p), { policymeta: updatedPolicymeta });
        });
        this.VueStoreFactory.dispatch("SET_POLICIES", __assign(__assign({}, currentWrapper), { policies: updatedPolicies }));
    };
    return PoliciesStoreService;
}());
exports.default = PoliciesStoreService;
PoliciesStoreService.$inject = ["VueStoreFactory"];
